<template>
  <div
    class="type-body-md grid h-screen grid-rows-[auto_1fr_auto] overflow-hidden bg-avtalat-gray"
  >
    <slot></slot>
  </div>
</template>
